import { render } from "./ProgressSteps.vue?vue&type=template&id=065000bc&scoped=true"
import script from "./ProgressSteps.vue?vue&type=script&lang=js"
export * from "./ProgressSteps.vue?vue&type=script&lang=js"

import "./ProgressSteps.vue?vue&type=style&index=0&id=065000bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-065000bc"]])

export default __exports__